import styled from "styled-components";
import { Link } from "react-router-dom";

export const MainContainer = styled.div`
  width: 100%;
  padding-left: 250px;
`

export const Container = styled.div`
  width: 100%;
  padding: 1rem;
  background: #ffffff;
`;

export const Title = styled.h1`
  width: 100%;
  padding-bottom: 5px;
  color: #000000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const LinkRedirect = styled(Link)`
  width: 120px;
  height: 40px;
  background: transparent;
  color: #ffffff;
  font-weight: bold;
  border: 1px solid #ffffff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    color: #000000 !important;
    background: #ffffff;
  }
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;

  color: rgba(0, 0, 0, 0.87);
`;

export const GridColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  width: 260px;
  height: max-content;
  background: #767676;
  border: none;
  border-radius: 5px;
`;

export const InlineField = styled.div`
  width: 100%;
  height: max-content;
  padding: 10px;
  display: flex;
  flex-direction: column;

  i {
    color: #ffffff;
    margin-top: 10px;
    font-size: 46px;
  }

  h3 {
    margin: 0;
    height: ${(props) => (props.bigTitle ? "110px" : "60px")};
    font-size: 23px;
    color: #ffffff;

    &::after {
      background: none;
    }
  }

  p {
    font-family: sans-serif;
    font-size: 14;
    font-weight: 700;
    color: #ffffff;
    text-align: center;
    width: 120px;
  }

  div {
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-bottom: 4px;
  }
`;

export const ContainerResolve = styled.div`
  width: 100%;
  /* margin-top:1rem; */
`;